// import { PlayIcon } from "@radix-ui/react-icons"
import { Fragment, useState, useEffect } from "react"
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next'

import Loader from "../Loader/Loader";
import Modal from "../Modal/Modal";
import { useStore } from "../../hook-store/store"
import { 
  getObjectFile, 
  getOriginalFileNameFromKey,
  getObjectSignedUrl,
} from '../../utils/bucket/bucket-object-util';

import { marks } from "../../utils/marks";
import { 
  loginPageLink, 
  KURASTORAGE_BACKENDURL,
} from "../../App";

const LoadParamFile = (props) => {
  const {
    setInputFile,

    setSelectedFileUrl,
    setSelectedDisplayImage,
  } = props;


  // const { toast } = useToast()

  const [t] = useTranslation('translation');

  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const [store, dispatch] = useStore();
  const { 
    // showToggleNav, 
    // gLoading,
    isAuth,
   } = store.uiStore;

   const [showLoadFileModal, setShowLoadFileModal] = useState(false);
   const [loadMoadlContent, setLoadModalContent] = useState();
   const [isLoading, setIsLoading] = useState(false);

  //  useEffect(() => {

  //  }, [imageHeight, imageWidth]);

  const loginRequireContent = (
    <div>
      <div>
        {t('fileControl01' ,'Login is required for loading file')} 
        {' '}
        from Kura Storage.
      </div>
      <br/>
      <div>
        <a href={loginPageLink} >
          <button>
            {marks.signInMrak} {t('fileControl02' ,'Login')}
          </button>
        </a>
      </div>
    </div>
  );

  const differentUserContent = (
    <div>
      <div>
        {t('fileControl03' ,'Login user is different. To load file, please login using same email address after logout from menu.')}
      </div>
      <br/>

      <div>
        {t('fileControl04' ,'Current Login User Email')}
        {' '}
        : {localStorage.getItem('email')}
      </div>
    </div>
  );

   useEffect(() => {
      loadParamFileHandler();
   },[isAuth]);


   const loadParamFileHandler = async () => {
    try {
      setShowLoadFileModal(false);
      setLoadModalContent('');

      const currentUrl = new URL(window.location.href);
      const queryParams = currentUrl.searchParams;
      const key = queryParams.get('key');
      const mimeType = queryParams.get('mimeType');
      const kuraStorageUserId = queryParams.get('kuraStorageUserId');
      const pathname = window.location.pathname;
      
      let keyData = queryParams.get('keyData');
      console.log('key', key);
      console.log('keyData', keyData)

      
      if (keyData) {
        keyData = JSON.parse(keyData);
      }


      // console.log('loadParam', key, mimeType);
      if (kuraStorageUserId) {

        if (!isAuth && !localStorage.getItem('userId')) {
          // alert('login-is-required');
          setShowLoadFileModal(true);
          setLoadModalContent(loginRequireContent);
          
          return;
        }

        if (isAuth && kuraStorageUserId !== localStorage.getItem('userId')) {
          // alert('auth-user-is-different');
          setShowLoadFileModal(true);
          setLoadModalContent(differentUserContent);

          return;
        }

        setIsLoading(true);

        if (keyData && !isLoading) {
          const paramFiles = await getKeyDataFileHandler(keyData);
          
          // console.log(paramFiles);
        } 

        console.log('resData, key', key, mimeType, queryParams)
        if (key && mimeType && !isLoading) {
          const paramFile = await getObjectFileHandler(
            key,
            mimeType,
            ''
          );
  
          console.log('param file', paramFile);
  
          if (paramFile) {
            dispatch('SET_PARAMFILEDATA', {
              key: key,
              mimeType: mimeType,
              // url: signedUrl,
              file: paramFile,
              openApp: queryParams.get('openApp'),
            });
          }
        }

        const openApp = queryParams.get('openApp');

        searchParams.delete('key');
        searchParams.delete('mimeType');
        searchParams.delete('kuraStorageUserId');
        searchParams.delete('openApp');
        searchParams.delete('keyData');
        setSearchParams(searchParams);

        if (openApp === 'voiceGenerator') {
          // dispatch('SET_GLOADING', false);
          setIsLoading(false);
          navigate('/voice-generator');
        }

        if (openApp === 'audioSlicer') {
          // dispatch('SET_GLOADING', false);
          setIsLoading(false);
          navigate('/audio-editor');
        }
        


        // dispatch('SET_GLOADING', false);
        setIsLoading(false);
        // window.history.push(window.location.pathname + "?" + currentUrlParams.toString());
      }
    
    } catch(err) {
      console.log(err);
      // dispatch('SET_GLOADING', false);
      setIsLoading(false);
    }
   }


   const getObjectFileHandler = async (
      key, 
      mimeType, 
      pathname,
    ) => {
      try {
        // console.log('resData key', key, mimeType, pathname)
        setIsLoading(true);
        dispatch('SHOW_NOTIFICATION', {
          status: '',
          title: `file downloading...`,
          message: '',
        });

        const signedUrl = await getObjectSignedUrl(
          KURASTORAGE_BACKENDURL,
          localStorage.getItem('token'),
          localStorage.getItem('userId'),
          key,
        );
        // console.log('signedUrl', signedUrl);

        // 2. Fetch the actual file data via the presigned URL
        const result = await fetch(signedUrl.data.url);
        // const resData = await fileResponse.blob();

        // console.log('signedUrl resData', resData)
        if (!result.ok) {
          throw new Error('error occured');
        } 

        // 1. Get the total file size from headers
        const contentLength = result.headers.get('content-length');
        const totalBytes = parseInt(contentLength, 10);
        
        if (isNaN(totalBytes)) {
            console.log("Server did not send Content-Length header. Progress cannot be tracked accurately.");
        }

        // 2. Read the stream chunk by chunk
        const reader = result.body.getReader();
        let loadedBytes = 0;
        const chunks = []; // Store chunks to reconstruct the file later

        while(true) {
            const { done, value } = await reader.read();
            
            if (done) break;
            
            chunks.push(value);
            loadedBytes += value.length;
            // console.log('loadedBytes', loadedBytes);

            // 3. Calculate percentage
            if (totalBytes) {
                const percentCompleted = Math.round((loadedBytes / totalBytes) * 100);
                // console.log(`Progress: ${percentCompleted}% (${loadedBytes}/${totalBytes} bytes)`);
                
                if (dispatch) {
                  dispatch('SHOW_NOTIFICATION', {
                    status: '',
                    title: `file downloading... ${percentCompleted}%`,
                    message: '',
                  });
                  
                  if (loadedBytes === totalBytes) {
                    setTimeout(() => {
                      dispatch('CLEAR_NOTIFICATION');
                    },1000 * 3);
                  }
                }
                // document.getElementById('progress-text').innerText = `${percentCompleted}%`;
            }
        }

        // 4. Combine chunks into a single Blob
        const resData = new Blob(chunks);

        // const resData = await getObjectFile(
        //   KURASTORAGE_BACKENDURL,
        //   localStorage.getItem('token'),
        //   localStorage.getItem('userId'),
        //   key,
        //   mimeType,
        //   dispatch,
        // );

        if (resData) {
          console.log('resData', resData);

          const originalName = getOriginalFileNameFromKey(decodeURI(key)); //// to match display in kura-storage

          const file = new File([resData], originalName, {type: mimeType});
          // console.log('loadparam file', file);
          if (file) {
            return file;
          }
        }

        setIsLoading(false);

      } catch(err) {
        console.log(err);
        setIsLoading(false);

        dispatch('SHOW_NOTIFICATION', {
          status: 'error',
          title: `download file failed`,
          message: '',
        });

        throw err;
      }
    };


    const getKeyDataFileHandler = async (keyData) => {
      try {
        setIsLoading(true);
        dispatch('SHOW_NOTIFICATION', {
          status: '',
          title: `file downloading...`,
          message: '',
        });

        // console.log('keyData', keyData)
        const currentUrl = new URL(window.location.href);
        const queryParams = currentUrl.searchParams;
        const openApp = queryParams.get('openApp');

        const keyFiles = keyData.files;
        const fileData = {
          files: [],
          openApp: openApp,
        };


        let fileIdx = 0;

        for (const keyFile of keyFiles) {
          // console.log('keyFiles', keyFiles)

          // console.log('fileIdx', fileIdx);
          const signedUrl = await getObjectSignedUrl(
            KURASTORAGE_BACKENDURL,
            localStorage.getItem('token'),
            localStorage.getItem('userId'),
            keyFile.key,
          );
          // console.log('signedUrl', signedUrl);

          // 2. Fetch the actual file data via the presigned URL
          const result = await fetch(signedUrl.data.url);
          // const resData = await fileResponse.blob();

          // console.log('signedUrl resData', resData)
          if (!result.ok) {
            throw new Error('error occured');
          } 

          // 1. Get the total file size from headers
          const contentLength = result.headers.get('content-length');
          const totalBytes = parseInt(contentLength, 10);
          
          if (isNaN(totalBytes)) {
              console.log("Server did not send Content-Length header. Progress cannot be tracked accurately.");
          }

          // 2. Read the stream chunk by chunk
          const reader = result.body.getReader();
          let loadedBytes = 0;
          const chunks = []; // Store chunks to reconstruct the file later

          while(true) {
              const { done, value } = await reader.read();
              
              if (done) break;
              
              chunks.push(value);
              loadedBytes += value.length;
              // console.log('loadedBytes', loadedBytes);

              // 3. Calculate percentage
              if (totalBytes) {
                  const percentCompleted = Math.round((loadedBytes / totalBytes) * 100);
                  // console.log(`Progress: ${percentCompleted}% (${loadedBytes}/${totalBytes} bytes)`);
                  
                  if (dispatch) {
                    dispatch('SHOW_NOTIFICATION', {
                      status: '',
                      title: `file ${fileIdx + 1} downloading...  ${percentCompleted}%`,
                      message: '',
                    });
                    
                    if (loadedBytes === totalBytes) {
                      setTimeout(() => {
                        dispatch('CLEAR_NOTIFICATION');
                      },1000 * 3);
                    }
                  }
                  // document.getElementById('progress-text').innerText = `${percentCompleted}%`;
              }
          }

          // 4. Combine chunks into a single Blob
          const resData = new Blob(chunks);

          // const resData = await getObjectFile(
          //   KURASTORAGE_BACKENDURL,
          //   localStorage.getItem('token'),
          //   localStorage.getItem('userId'),
          //   keyFile.key,
          //   keyFile.mimeType,
          //   dispatch,
          // );
  
          if (resData) {
            console.log(resData);
  
            const originalName = getOriginalFileNameFromKey(decodeURI(keyFile.key)); //// to match display in kura-storage
            
            let fileMimeType = keyFile.mimeType;

            if (!fileMimeType) {
              fileMimeType = 'audio/wav';

              // const lowerKey = keyFile.key.toLowerCase();
              // const ext = lowerKey.split('.').pop();
              
              // if (ext === 'png') {
              //   fileMimeType = 'image/png'
              // }
            }
  
            const file = new File([resData], originalName, { type: fileMimeType });

            if (file) {
              fileData.files.push(file);
            }
          }

          fileIdx = fileIdx + 1;

        }

        dispatch('SET_PARAMFILEDATALIST', fileData);
        
        //// open target app modal

        // if (openApp === 'imageToImageGeneration') {
        //   dispatch('SET_SHOWIMAGETOIMAGESETTINGS', true);
        // }


        // dispatch('SET_SHOWLOADFILEMODAL', false);

        setIsLoading(false);

        return fileData;
      } catch(err) {
        console.log(err);
        setIsLoading(false);

        dispatch('SHOW_NOTIFICATION', {
          status: 'error',
          title: `download file failed`,
          message: '',
        });
        // setLoadModalContent(loadErrorContent);
        throw err;
      }
    };




  return (
    <Fragment>
      {showLoadFileModal && (
        <Modal
          onClose={() => {
            setShowLoadFileModal(false);
          }}
        >
          <div>
            {loadMoadlContent}
          </div>
        </Modal>
      )}
      {isLoading && (
        <Loader />
      )}
    </Fragment>
  )
}

export default LoadParamFile;
